<template>
    <section>
        <div class="row">
            <div class="col-12 wrapper">
                <h1 class="text-uppercase text-center text-danger my-5 font-weight-bold">
                    Kontak
                </h1>
                <div class="row mb-4">
                    <div class="col-lg-6">
                        <h2 class="text-center text-uppercase font-weight-bold">
                            Cabang
                        </h2>
                        <div class="row justify-content-center mb-5">
                            <div v-for="(branch, index) in primaryBranches" v-if="!branch.isHidden" v-bind:data-id="branch.id" class="col-lg-6">
                                <div class="content text-center">
                                    <a v-bind:href="getWaLink(branch)" class="cabang-link d-inline-block mb-3" target="_blank">
                                        <div class="cabang-card">
                                            <img v-bind:src="branch.imageUrl" class="img-fluid" v-bind:alt="branch.name" />
                                        </div>
                                    </a>
                                    <h3 class="text-uppercase font-weight-bold text-danger">{{ branch.name }}</h3>
                                    <p class="font-weight-medium">
                                        {{ branch.address }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <h2 class="text-center text-uppercase font-weight-bold">
                            Mitra
                        </h2>
                        <div class="row justify-content-center mb-5" >
                            <div v-for="(branch, index) in branches" v-if="!branch.isHidden" v-bind:data-id="branch.id" class="col-lg-6">
                                <div class="content text-center">
                                    <a v-if="getWaLink(branch)" v-bind:href="getWaLink(branch)" class="cabang-link d-inline-block mb-3" target="_blank">
                                        <div class="cabang-card">
                                            <img v-bind:src="branch.imageUrl" class="img-fluid" v-bind:alt="branch.name" />
                                        </div>
                                    </a>
                                    <img v-else v-bind:src="branch.imageUrl" class="img-fluid mb-3" />
                                    <h3 class="text-uppercase font-weight-bold text-danger">{{ branch.name }}</h3>
                                    <p class="font-weight-medium">
                                        {{ branch.address }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 px-4">
                        <form v-on:submit.prevent="save">
                            <h2 class="text-center text-uppercase font-weight-bold mb-4">
                                Kirim Pesan
                            </h2>
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <label class="font-weight-medium h4 required">Nama</label>
                                    <input v-model="form.name" class="form-control form-control-sm" required />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <label class="font-weight-medium h4 required">Email</label>
                                    <input v-model="form.email" type="email" class="form-control form-control-sm" required />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <label class="font-weight-medium h4 required">No HP</label>
                                    <input v-model="form.city" class="form-control form-control-sm" required />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <label class="font-weight-medium h4 required">Alamat</label>
                                    <textarea v-model="form.address" class="form-control form-control-sm" required></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mb-2">
                                    <label class="font-weight-medium h4 required">Pesan Anda</label>
                                    <textarea v-model="form.message" class="form-control form-control-sm" required></textarea>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-auto mt-4">
                                    <button type="submit" class="btn btn-sm btn-danger px-5">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
	<div class="row">
            <div class="col text-center mt-5">
                <Adsense v-bind:data-ad-client="googleAdsClientKey" data-ad-slot="8773918261"></Adsense>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "StaticAbout",
        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    city: '',
                    address: '',
                    message: ''
                },
		googleAdsClientKey: process.env.GOOGLE_ADS_CLIENT,
                branches: [{}, {}, {}, {}, {}, {}],
                primaryBranches: [{}, {}, {}, {}, {}, {}]
            };
        },
        methods: {
            getWaNumber(branch) {
                if (!branch.address) return '';
                const match = branch.address.match(/\b(?:wa|whatsapp|whats\s*app|whatsap|watsap)\b[\s\S]*?((?:0|62)8[\d\-\s+]{6,})/i);
                if (match) {
                    let phone = match[1].replace(/\D/g, '');
                    return phone.startsWith('0') ? '62' + phone.substring(1) : phone;
                }
                if (branch.isPrimary) {
                    const fallbackMatch = branch.address.match(/(?:62|0)8\d{8,11}/);
                    if (fallbackMatch) {
                        let phone = fallbackMatch[0].replace(/\D/g, '');
                        return phone.startsWith('0') ? '62' + phone.substring(1) : phone;
                    }
                }
                return '';
            },
            getWaLink(branch) {
                const phone = this.getWaNumber(branch);
                if (!phone) return null;
                const text = encodeURIComponent(`Halo, boleh tanya mengenai Program Bimbingan di ${branch.name}?`);
                return `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;
            },
            save() {
                this.axios.post(process.env.API_URL + '/site/contact', this.form).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            fetchData() {
                this.axios.get(process.env.API_URL + '/branch', {params: {isHidden: false}}).then(response => {
                    var data = response.data.data;
                    this.branches = data.filter(branch => {
                        return !branch.isPrimary;
                    });
                    this.primaryBranches = data.filter(branch => {
                        return branch.isPrimary;
                    });
                });
            }
        },
        created() {
            this.fetchData();
        },
        mounted() {
            document.title = 'Contact Us - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .content{ padding: 30px; font-size: 0.8rem; }
    .content img{ height: 200px; object-fit: contain; }
    .cabang-card {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        border-radius: 12px;
        padding: 5px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .cabang-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05);
    }
    .cabang-link {
        display: block;
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/static/Contact.vue